<div
  class="eventq-site-stat-flag"
  [class.eventq-site-stat-flag--armed]="armed()"
  [class.eventq-site-stat-flag--disarmed]="!armed()"
>
  <div class="eventq-site-stat-flag__heading">
    <mat-icon>{{ armed() ? 'verified_user' : 'security' }}</mat-icon>
    <span>{{ displayLabel() }}</span>
  </div>
  <div class="eventq-site-stat-flag__count">{{ formattedCount() }}</div>
</div>
